import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import debug from './../../debug';
import AuditStore from '../../stores/AuditStore';
import SnackStore from '../../stores/SnackStore';
import { TextWithTitle, } from '../ConsoleFragments';
import ConsoleAuditDetailsModal from './ConsoleAuditDetailsModal';
import { Card, Page, Table } from '../Fuse';
import './ConsoleAudit.css';

const block = b.lock('ConsoleAudit');

class ConsoleAudit extends Component {
    static propTypes = {
        audit: AuditStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
        location: PropTypes.shape({
            query: PropTypes.shape({
                openModal: PropTypes.string,
                search: PropTypes.string
            })
        }),
    };

    openRevisionModal(search) {
        const { audit } = this.props;
        try {
            const queries = audit.urlToSearchParams(search);
            const results = audit.filterData(audit.list, {
                queries
            });
            if (results.length) {
                audit.modal.open(results[0].id);
            } else {
                throw new Error('Unable to find an audit entry to open');
            }
        } catch (e) {
            debug.recordError(e);
        }
    }

    componentWillMount() {
        const { location } = this.props;
        const { query } = location || {};

        this.props.audit.load()
            .then(() => {
                if (query && query.openModal === 'true') {
                    this.openRevisionModal(query.search);
                }
            })
            .catch((error) => error && this.props.snack.showError(
                `Failed to load audit log. ${error.message}.`));
    }

    columns = [{
        name: 'action',
        title: 'Action',
    }, {
        name: 'target',
        title: 'Changes To',
    }, {
        name: 'time',
        title: 'Date and Time (GMT)',
    }, {
        name: 'actor',
        title: 'Actor',
    }].map((column) => ({
        ...column,
        render: (item) => <TextWithTitle text={item[column.name] || '—'} />,
    }));

    render() {
        const { audit } = this.props;
        return <Page title="Audit Log">
            <Card className={block('Card')}>
                <Table
                    columns={this.columns}
                    loading={audit.loadStatus.isLoading}
                    search={audit.search}
                    items={audit.filteredList}
                    cellClassName={block('Cell')}
                    rowClassName={block('Row')}
                    onRowClick={(item) => audit.modal.open(item.id)}
                    pagination
                    focusedItemId={audit.modal.id}
                />
            </Card>
            <ConsoleAuditDetailsModal />
        </Page>;
    }
}

export default inject('audit', 'snack')(observer(ConsoleAudit));
